import { EntityBuilder } from '../../domain/entity/builder'
import { XDStorageRequest } from '../storage/global/request'
import { LocalStore } from '../storage/local'
import { XDActions } from './actions'
import { IXDRequest, XDRequest } from './request'
import { IXDResponse, XDResponse } from './response'

// expect implementing page to pass origin in hash
const origin = decodeURIComponent(location.hash.substr(1))
location.hash = ''

// listen for messages
window.addEventListener('message', (e) => {
    if (e.origin !== origin) {
        return
    }

    const req: IXDRequest<any> = EntityBuilder.buildOne<XDRequest<any>>(XDRequest, e.data)
    if (req.validate()) {
        let res: IXDResponse

        /**
         * Handle actions. Only storage related currently.
         */
        if (req.action === XDActions.DELETE) {
            LocalStore.delete((req as XDStorageRequest<any>).key)
            res = new XDResponse(XDActions.ACK, req.id)

        } else if (req.action === XDActions.GET) {
            res = new XDResponse(XDActions.ACK, req.id, LocalStore.get((req as XDStorageRequest<any>).key))
        } else if (req.action === XDActions.SET) {
            LocalStore.set((req as XDStorageRequest<any>).key, req.data, (req as XDStorageRequest<any>).exp)
            res = new XDResponse(XDActions.ACK, req.id)
        }

        if (res) {
            (e.source as Window).postMessage(res.send(), origin)
        }
    }
})
